<template>
  <section v-if="references?.length" class="references pe-section">
    <h3>
      References
      <SectionActions
        v-show="isPowerEdit"
        class="actions"
        section="references"
      />
    </h3>
    <section class="list">
      <template v-for="(ref, index) in references" :key="ref.name">
        <section v-if="ref.name || ref.reference" class="reference">
          <ItemActions
            v-show="isPowerEdit"
            class="itemActions"
            :index="index"
            section="references"
            :uuid="ref.uuid"
            :actions="['edit', 'delete']"
          />
          <div
            v-editable="isPowerEdit"
            :data-target-path="`resume.references.${index}.name`"
            class="name"
            v-text="ref.name"
          ></div>
          <span
            class="quote"
            v-editable="isPowerEdit"
            :data-target-path="`resume.references.${index}.reference`"
            v-text="ref.reference"
          ></span>
        </section>
      </template>
    </section>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { Resume } from '@/types/resume/v1'
import { useStructuredResumeStore } from '@/store/pinia/structuredResume'
import SectionActions from './SectionActions.vue'
import ItemActions from './ItemActions.vue'

export default defineComponent({
  name: 'References',
  components: {
    SectionActions,
    ItemActions,
  },
  props: {
    references: {
      type: Object as PropType<Resume.Reference[]>,
      required: false,
    },
  },
  setup() {
    const store = useStructuredResumeStore()

    return { isPowerEdit: store.isPowerEdit }
  },
})
</script>

<style lang="postcss" scoped>
.references {
  @apply pt-6-em;
  h3 {
    @apply leading-none text-xl-em flex items-center;
    .actions {
      @apply hidden;
    }
    &:hover {
      .actions {
        @apply flex;
      }
    }
  }
  .list {
    .reference {
      @apply pt-4-em leading-[inherit] relative;
      .itemActions {
        @apply hidden;
      }
      &:hover {
        .itemActions {
          @apply flex;
        }
      }
      .name {
        @apply font-semibold mb-1-em;
      }
      .quote {
        @apply text-sm-em block whitespace-pre-wrap leading-normal;
      }
    }
  }
}
</style>
